import React from 'react'

function InsightTools() {
  return (
    <section class="insights-tool-main ">
    <div class="container">
      <div class="insight-text pt-5">
        <h5 class="fw-bold mb-5">Insights & Tools</h5>
      </div>
      <div class="row row-cols-1 row-cols-lg-2 justify-content-between">
        <div class="card col insight-crd position-relative ">
          <div class="card-body insight-bd d-lg-flex justify-content-between">
            <div class="insight-left col-12 col-lg-4">
              <h5 class="text-white fw-bold">
                AI Tools In Real Estate Industry
              </h5>
              <a href="#" class="text-decoration-none text-white">
                Explore all <i class="bi bi-caret-right-fill"></i>
              </a>
            </div>
            <div class="insight-right ">
              <img
                class="insight-ai-img"
                src="images/illustration/insight-1-removebg-preview.png"
                alt=""
              />
            </div>
          </div>
        </div>
        {/* <div class="card col insight-crd position-relative mt-5 mt-lg-0">
          <div class="card-body insight-bi-bd d-lg-flex  justify-content-lg-between">
            <div class="insight-left col-12 col-lg-4 p-2">
              <h5 class=" fw-bold">BI Tools In Real Estate Industry</h5>
              <a href="#" class="text-decoration-none text-dark">
                Explore all <i class="bi bi-caret-right-fill"></i>
              </a>
            </div>
            <div class="insight-right">
              <img
                class="insight-bi-img"
                src="images/illustration/insight-2-removebg-preview.png"
                alt=""
              />
            </div>
          </div>
        </div> */}
      </div>
    </div>
  </section>
  )
}

export default InsightTools